import React, { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const LogoutPage: React.FC<{}> = () => {
  console.log('at LogoutPage render')
  const { logout: authLogout } = useAuth();

  // Remove all session data including closed banners
  sessionStorage.clear();

  const logout = () => {
    // Use new authentication system
    authLogout();

    // For BankID logout, we might not need to redirect to OAuth server
    // Just redirect to home page after clearing tokens
    window.location.href = window.location.origin;
  }

  useEffect(() => logout(), [])

  return <div style={{ textAlign: 'center', padding: '40px' }}>Du loggas ut...</div>
}

export default LogoutPage
